import { createStorefrontClient } from '@template-project/storefront-bff-client';
import type {
  CreateShippingAddressInput,
  ShippingAddress,
  UpdateShippingAddressInput,
} from '@template-project/storefront-bff-client';
import { env } from '@/lib/utils/env';

export type {
  CreateShippingAddressInput,
  ShippingAddress,
  UpdateShippingAddressInput,
} from '@template-project/storefront-bff-client';

function getBffClient() {
  return createStorefrontClient({
    baseUrl: env.STOREFRONT_BFF_URL,
    tenantId: env.FUNNELS_TENANT_ID,
  });
}

class ShippingAddressService {
  async getAddresses(): Promise<ShippingAddress[]> {
    const result = await getBffClient().getShippingAddresses();
    return result.data;
  }

  async getAddress(addressId: string): Promise<ShippingAddress> {
    const result = await getBffClient().getShippingAddress(addressId);
    return result.data;
  }

  async createAddress(input: CreateShippingAddressInput): Promise<ShippingAddress> {
    const result = await getBffClient().createShippingAddress(input);
    return result.data;
  }

  async updateAddress(addressId: string, input: UpdateShippingAddressInput): Promise<ShippingAddress> {
    const result = await getBffClient().updateShippingAddress(addressId, input);
    return result.data;
  }

  async deleteAddress(addressId: string): Promise<void> {
    await getBffClient().deleteShippingAddress(addressId);
  }
}

export const shippingAddressService = new ShippingAddressService();
